// src/components/WhatsappButton.js
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappButton = () => {
  return (
    <a
      href="https://wa.me/543512191101?text=Hola%20quiero%20consultar%20sobre%20sus%20productos"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-green-500 rounded-full p-4 shadow-lg hover:bg-green-600 transition transform hover:scale-110 z-50"
    >
      <FaWhatsapp className="text-white text-3xl" />
    </a>
  );
};

export default WhatsappButton;
